module.exports = __webpack_public_path__ + "static/media/justin.3c789232.jpg";